import React, { useEffect, useRef, useState } from "react";
import { withSnackbar } from "notistack";
import { IconButton, Tooltip } from "@mui/material";
import { Edit as IconEdit } from "@mui/icons-material";

import UiDialog from "components/Custom/UiDialog";
import Btn from "components/Custom/Btn";
import Loader from "components/Custom/Loader";
import ExcelGrid from "components/Custom/ExcelGrid";
import { NOTIFY } from "common/config";
import { COLORS } from "common/colors";
import { DEFAULTS } from "common/config";
import {
  LABELS,
  WARNINGS,
  TITLES,
  SUCCESS,
  ERRORS,
  SUB_TITLES,
} from "common/lables";
import { COMMON_JS } from "common/scripts";
import TxtRow from "components/Custom/TxtRow";

import { MASTER_APIs } from "apihandlers/master";

const Page = (props: any) => {
  const { setDashMenu } = props;

  const [loading, setLoading] = useState(true);
  const [isSubmit, setIsSubmit] = useState(false);
  const [rows, setRows] = useState<any>(null);
  const [manageDialog, setManageDialog] = useState(false);
  const [selectedRow, setSelectedRow] = useState<any>({});
  const [mandatoryResults, setMandatoryResults] = useState<any[]>([]);

  const COLUMNS = [
    {
      key: "slNo",
      name: LABELS.SL_NO,
      width: "5%",
      type: "number",
      align: "center",
      headerAlign: "center",
      editable: false,
      sortable: true,
      searchable: true,
    },
    {
      key: "screen",
      name: LABELS.SCREEN,
      width: "45%",
      type: "text",
      align: "center",
      editable: false,
      sortable: true,
      searchable: true,
    },
    {
      key: "pageType",
      name: LABELS.PAGE_TYPE,
      width: "45%",
      type: "number",
      align: "center",
      editable: false,
      sortable: true,
      searchable: true,
    },

    // {
    //   key: "activeStatusText",
    //   name: LABELS.ACTIVE,
    //   width: "5%",
    //   type: "dropdown",
    //   filters: [
    //     { id: "yes", name: "Yes" },
    //     { id: "no", name: "No" },
    //   ],
    //   editable: false,
    //   sortable: true,
    //   searchable: true,
    // },
    {
      key: "options",
      name: "Options",
      width: "5%",
      renderCell: (params) => (
        <div className="options">
          <Tooltip title={LABELS.EDIT} placement="bottom">
            <IconButton
              className="iconBtn"
              onClick={() => onEditRow(params.row)}
            >
              <IconEdit />
            </IconButton>
          </Tooltip>
        </div>
      ),
    },
  ];

  useEffect(() => {
    if (loading) {
      getRows();
    }
  }, [loading]);

  const getRows = async () => {
    try {
      const args = {
        pageNo: 1,
        pageLength: DEFAULTS.PAGE_LENGTH,
      };
      const res: any = await MASTER_APIs.getPages(args);
      const { status, response } = res;
      if (status === 200) {
        let list = response.records;
        for (let i = 0; i < response.records.length; i++) {
          list[i]["slNo"] = i + 1;
          //   if (list[i]["activeStatus"]) {
          //     list[i]["activeStatusText"] = "Yes";
          //   } else {
          //     list[i]["activeStatusText"] = "No";
          //   }
        }
        setRows(list);
        setLoading(false);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const onEditRow = (row: any) => {
    setSelectedRow(row);
    setManageDialog(true);
    console.log(selectedRow);
  };

  const manageRecord = () => {
    const screen = (
      document.getElementById("screen") as HTMLInputElement
    ).value.trim();

    const pageType = (
      document.getElementById("pageType") as HTMLInputElement
    ).value.trim();

    // const active = document.querySelector(
    //   'input[name="activeStatus"]:checked'
    // ) as HTMLInputElement;
    // const activeStatus = active ? active.value : "";
    //todo:Validations needs to be done

    // Validations
    let errors = [];
    if (screen === "") {
      errors.push({
        id: "screen",
        msg:
          "<span class='bold'>" +
          LABELS.SCREEN +
          "</span> " +
          WARNINGS.IS_A_REQUIRED_FIELD,
      });
    }
    if (pageType === "") {
      errors.push({
        id: "pageType",
        msg:
          "<span class='bold'>" +
          LABELS.PAGE_TYPE +
          "</span> " +
          WARNINGS.IS_A_REQUIRED_FIELD,
      });
    }

    setMandatoryResults(errors);
    if (errors.length > 0) {
      COMMON_JS.showNotify(
        props,
        NOTIFY.WARNING,
        WARNINGS.PLEASE_CHECK_FORM_ERRORS
      );
      return;
    }

    const args = {
      id: selectedRow.id || -1,
      screen,
      pagetType: pageType,
    };
    console.log("args", args);
    setIsSubmit(true);
    MASTER_APIs.managePage(args).then((res) => {
      setIsSubmit(false);
      if (res.status === 200) {
        COMMON_JS.showNotify(props, NOTIFY.SUCCESS, SUCCESS.RECORD_SUCCESS);
        setSelectedRow({});
        setManageDialog(false);
        reloadGrid();
      } else {
        COMMON_JS.showNotify(props, NOTIFY.ERROR, ERRORS.RECORD_FAILED);
      }
    });
  };

  const reloadGrid = () => {
    setRows(null);
    getRows();
  };

  const onAdd = () => {
    setSelectedRow({});
    setManageDialog(true);
  };

  console.log("selectedRow", selectedRow);

  return (
    <React.Fragment>
      <div className="pageInfo">
        <ul className="breadcrumbs">
          <li onClick={() => setDashMenu("")}>{LABELS.HOME}</li>
          <li className="dim">{" / "}</li>
          <li onClick={() => setDashMenu(LABELS.HOME)}>{LABELS.MASTERS} </li>
          <li className="dim">{" / "}</li>
          <li className="active">{TITLES.PAGE}</li>
        </ul>
        <h4>{TITLES.PAGE}</h4>
        <p>{SUB_TITLES.PAGE}</p>
      </div>

      <div className="grid excelGridWrapper">
        {
          rows && (
            <ExcelGrid
              id={"page"}
              height={window.innerHeight * 0.8}
              cols={COLUMNS}
              rows={rows}
              exportOption={true}
              newRowOption={false}
              exportName={LABELS.PAGE}
              onReload={reloadGrid}
              onAdd={onAdd}
            />
          )
          // : (
          //   <div className="flexRowCenter">
          //     <Loader />
          //   </div>
          // )
        }
      </div>

      {manageDialog && (
        <UiDialog
          title={
            selectedRow.id
              ? "Edit " + LABELS.PAGE + ": " + selectedRow.screen
              : "Add New " + LABELS.PAGE
          }
          open={true}
          size={"sm"}
          onClose={() => {
            setManageDialog(false);
            setMandatoryResults([]);
          }}
        >
          <div className="formGroup required">
            <TxtRow
              id={"screen"}
              type={"text"}
              label={LABELS.SCREEN}
              required={true}
              defaultValue={selectedRow.screen || ""}
              disabled={isSubmit}
            />
          </div>

          <div className="formGroup required">
            <TxtRow
              id={"pageType"}
              type={"number"}
              label={LABELS.PAGE_TYPE}
              defaultValue={selectedRow.pageType || ""}
              disabled={isSubmit}
              required={true}
            />
          </div>
          {/* 
          <div className="formGroup ">
            <label>{LABELS.ACTIVE_STATUS}</label>
            <RadioBtn
              list={[
                {
                  id: "true",
                  value: "true",
                  label: LABELS.ACTIVE,
                  checked: selectedRow.id
                    ? selectedRow.activeStatus === true
                    : true,
                  disabled: false,
                },
                {
                  id: "false",
                  value: "false",
                  label: LABELS.INACTIVE,
                  checked: selectedRow.id
                    ? selectedRow.activeStatus === false
                    : false,
                  disabled: false,
                },
              ]}
              row={true}
              name={"activeStatus"}
              disabled={isSubmit}
            />
          </div> */}

          {/* mandatoryResults */}
          {mandatoryResults.length > 0 && (
            <div className="mandatoryBox">
              <ul>
                {mandatoryResults.map((m) => {
                  return (
                    <li>
                      <span dangerouslySetInnerHTML={{ __html: m.msg }} />
                    </li>
                  );
                })}
              </ul>
            </div>
          )}
          <div className="formGroup submitBtnWrapper">
            <div className="flexbtnjustify">
              <Btn
                text={LABELS.CANCEL}
                loading={isSubmit}
                bgColor={COLORS.RELOAD_EXPORT}
                color={COLORS.RELOAD_EXPORT_TEXT}
                onClick={() => {
                  setManageDialog(false);
                  setMandatoryResults([]);
                }}
              />
              <Btn
                text={LABELS.SAVE}
                loading={isSubmit}
                onClick={manageRecord}
                bgColor={COLORS.SAVE_GREEN}
              />
            </div>
          </div>
        </UiDialog>
      )}
    </React.Fragment>
  );
};

export default withSnackbar(Page);
